import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { EXTERNAL_OR_APIGW_BY_ENV } from 'core/constants/endpoints'

export interface GetSignatureDocumentParams {
  documentId: string
  agentId: string
}

export interface GetSignatureDocumentResponse {
  error?: Error
  hcState: any
  compliance: any
  plan: {
    planId: number
    period: number
    policies: number
  }
}

async function getSignatureDocument({
  documentId,
  agentId
}: GetSignatureDocumentParams): Promise<GetSignatureDocumentResponse | undefined> {
  try {
    const url = `${EXTERNAL_OR_APIGW_BY_ENV}/v1/esignature/agent/${agentId}/document/${documentId}`
    const response = await fetchJSONHandleError({
      url
    })

    return response
  } catch (e) {
    console.error('Error fetching pivot document state: ', e)
    return undefined
  }
}

export default getSignatureDocument
